import { render } from "./index.vue?vue&type=template&id=43dec7f2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=43dec7f2&lang=scss&scoped=true"

import exportComponent from "D:\\gw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43dec7f2"]])

export default __exports__